import React from "react";
import "./Home.css";
const Home = () => {
  return (
    <div className="home__bg" id="Home">
      <div className="container">
        <div className="home__content">
          <div className="hom__meta">
            <h1 className="home__text pz__10">
              We come to you!
            </h1>

            <h2 className="home__text pz__10">Mobile car wash</h2>

            <h3 className="home__text sweet">Western Cape</h3>

            <h4 className="home__text pz__10">
            "Quality in every wash."
            </h4>
            <h3 className="home__text1">
            Experience the ultimate convenience of a professional car wash, wherever you are.
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
